// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { get } from '@tls/auth';

export function getEmaiVersionStorageKey(appBaseUrl = '') {
  return `sw91:lastSeenEmaiVersion:${appBaseUrl}`;
}

export function getEmaiReleaseLine(version: string): string {
  return version.trim().split('.').slice(0, 2).join('.');
}

export async function getCurrentEmaiVersion(): Promise<string> {
  const response = await get('Version/emai', false, true, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    params: { _: Date.now() },
  });

  const status = Number(response?.status);
  if (status !== 200) {
    throw new Error(`EMAI version request failed (${status || 'network error'})`);
  }

  if (response.data?.name !== 'emai' || typeof response.data?.version !== 'string' || !response.data.version.trim()) {
    throw new Error('Invalid EMAI version response');
  }

  return response.data.version.trim();
}
